import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AnnotationApiService, ApplicationApiService, ApplicationBidApiService, AuthenticationService, ContactApiService } from '../../data-services/index';
import { IAnnotationInput, IApplication, IApplicationBid, IApplicationBidInput, IApplicationInput, IApprovalTask, IContact, IContactInput, IHelp, IUser, UtilityService } from '@ebb-v2/ebb-integration';
import { DialogLdpUnlistedComponent } from '../dialog/dialog-ldpunlisted.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogUploadApplicationEngineeredBidData } from '../dialog/dialog-upload-applicationengineeredbid.component';
import { mergeMap, map, defaultIfEmpty } from 'rxjs/operators';
import { isNull } from 'util';
import { blobToBase64String } from 'blob-util';
import { forkJoin, from, Observable } from 'rxjs';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AppSheetHelpComponent } from '../../chrome/app-sheet-help.component';
@Component({
    selector: 'ebb-portal-ldp-form',
    templateUrl: './ldp-form.component.html',
    standalone: false
})
export class LdpFormComponent implements OnInit {
  @Input() application: IApplication;
  @Input() taskBuildingPermit: IApprovalTask;
  @Output() emitLdpUpdateEvent = new EventEmitter<IApplicationInput>();
  @Output() emitLdpFileUploadEvent = new EventEmitter<IApprovalTask>();
  public currentUser: IUser;
  public formldpInfo: FormGroup;
  public bidUploadResultContext;
  // Display Titles and Labels
  public taskRetrofitLdpTitle = 'Design Professional Information';
  public taskRetrofitLdpStatus = 'Pending';
  public taskRetrofitLdpSummary = 'Select Design Professional';
  public displayFirstBidLabel = 'SUBMIT ESTIMATE';
  public displaySecondBid = false;
  public displaySecondBidLabel: string;
   public retrofitLdp: IContact = null;
  public isLdpSelected= false;
  // States and Data
  public bids: IApplicationBid[];

  public currentDate: Date = new Date();

  // Configuration
  public formAutoSave = false;
  public saveBidProgressIndicator = false;
  public trainingUrl: string;
  public estimatemax = 10000;
  public bid1;
  public bid2;
  snackBar: any;
  public bidUploadResult;
  public bid1rejected = false;
  public bid1rejectedwhy: string;
  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService,
    private readonly apiApplication: ApplicationApiService,
    private readonly apiContact: ContactApiService,
    private readonly dialogLdpUnlisted: MatDialog,
    public readonly utilityService: UtilityService,
    private readonly authenticationService: AuthenticationService,
    private readonly apiApplicationBid: ApplicationBidApiService,
    private readonly dialogUpload: MatDialog,
    private readonly apiAnnotation: AnnotationApiService,
    private readonly infoSheet: MatBottomSheet,
  ) {}

  ngOnInit(): void {
    if(this.application.programCycle.maxEngineeredBidAmount != null &&  this.application.programCycle.maxEngineeredBidAmount>0){

      this.estimatemax = this.application.programCycle.maxEngineeredBidAmount;
    }
    this.initializeForm();
    this.loadCurrentUser();
    this.loadLdpInfoForm();
    const taskitems = this.taskBuildingPermit.approvalTaskItems;
    const bids = taskitems.filter(
      x => x.name === 'Design Professional Estimate' && x.payloadTypeCode === 700000001
    );
    bids.forEach(bid => {
      if (bid.statusCode === 700000002) {
        this.bid1rejected = true;
        this.bid1rejectedwhy = bid.reasonWhy;
      }
    });
  }

  private initializeForm(): void {
    this.formldpInfo = this.fb.group({
      ldp: [null],
      bid1: [null],
      bid2: [null],
    });
  }

  private loadCurrentUser(): void {
    this.currentUser = this.authService.currentUserValue;
  }
  public onLdpUnlistedEvent(): void {
    const dialogRef = this.dialogLdpUnlisted.open(
      DialogLdpUnlistedComponent,
      { panelClass: 'dialog-container-scroll' }
    );
    dialogRef.afterClosed().subscribe(
      data => {
        if (data) {
          this.saveBidProgressIndicator = true;
          const isexists: Boolean = data.isexists as Boolean;
          const newContact: IContactInput = data.contactInput as IContactInput;
          if(!isexists){
          this.apiContact.saveLdpUnlisted(newContact).subscribe(
            data => {
              const applicationInput: IApplicationInput = {} as IApplicationInput;
              const ldpId = data.id;
                         
              applicationInput._Ebb_LdpId = ldpId;
         
              this.application._Ebb_LdpId = ldpId;
              const con = new Date(data.createdOn);
              const today = new Date();
              today.setDate(today.getDate()-1);
              //console.log(`${con.getTime()} : ${today.getTime()}`)
              if(data.ldpManualEntry && con.getTime() < today.getTime())
              {
                this.saveBidProgressIndicator = false;
                  this.snackBar.open(`Your Ldp already exists in our system, please check the information. Contact us if any updates are needed at (877) 232-4300 or info@californiaresidentialmitigationprogram.com.`,'CONFIRM');
              }
             
              this.apiApplication
                .updateApplication(applicationInput, this.application.id)
                .subscribe(
                  () => {
                    this.emitLdpUpdateEvent.emit(applicationInput);
                    this.loadLdpInfoForm();
                    this.saveBidProgressIndicator = false;
                  },
                  error =>{
                    this.saveBidProgressIndicator = false;
                    console.warn(
                      `ERROR: LdpForm.onLdpUnlisted - ${JSON.stringify(
                        error
                      )}`
                      
                    )}
                );
            },
            error => {
              this.saveBidProgressIndicator = false;
              if (
                error.graphQLErrors[0] &&
                error.graphQLErrors[0].message === 'Duplicate Email'
              ) {
                this.snackBar.open(
                  `Please contact us at (877) 232-4300 or info@crmp.org to add Design Professional information to your application.`,
                  'CONFIRM'
                );
              } else {
                this.snackBar.open(
                  `Error selecting Design Professional. Please contact us at (877) 232-4300 or info@crmp.org to add Design Professional information to your application.`,
                  'CONFIRM'
                );
              }
              console.warn(
                `ERROR: LdpForm.onLdpUnlisted - ${JSON.stringify(
                  error
                )}`
              );
            }
          );
        }
        if(isexists){

          const Contact: IContact = data.contact as IContact;

 
          const ldpId = Contact.id;

          const applicationInput: IApplicationInput = {} as IApplicationInput;
                 
              applicationInput._Ebb_LdpId = ldpId;
         
          this.apiApplication
          .updateApplication(applicationInput, this.application.id)
          .subscribe(
            () => {
              this.emitLdpUpdateEvent.emit(applicationInput);
              this.loadLdpInfoForm();
              this.saveBidProgressIndicator = false;
            },
            error =>{
              this.saveBidProgressIndicator = false;
              console.warn(
                `ERROR: LdpForm.onLdpUnlisted - ${JSON.stringify(
                  error
                )}`
              )}
          );
        }
        }
      },
      error => {
        this.saveBidProgressIndicator = false;
        console.warn(
          `ERROR: LdpForm.onLdpUnlisted - ${JSON.stringify(
            error
          )}`
        );
      }
    );
  }

  public onLdp2ndUnlistedEvent(): void {
    const dialogRef = this.dialogLdpUnlisted.open(
      DialogLdpUnlistedComponent,
      { panelClass: 'dialog-container-scroll' }
    );
    dialogRef.afterClosed().subscribe(
      data => {
        if (data) {
          this.saveBidProgressIndicator = true;
          const isexists: Boolean = data.isexists as Boolean;
          const newContact: IContactInput = data.contactInput as IContactInput;
          if(!isexists){
          this.apiContact.saveLdpUnlisted(newContact).subscribe(
            data => {
              this.saveBidProgressIndicator = false;
              const ldpId = data.id;
                         
              this.showSubmitBid(
                '2ndBid',
                ldpId,
                data.fullName,
                false
              );
           
             
             
            },
            error => {
              this.saveBidProgressIndicator = false;
              if (
                error.graphQLErrors[0] &&
                error.graphQLErrors[0].message === 'Duplicate Email'
              ) {
                this.snackBar.open(
                  `Please contact us at (877) 232-4300 or info@crmp.org to add Design Professional information to your application.`,
                  'CONFIRM'
                );
              } else {
                this.snackBar.open(
                  `Error selecting Design Professional. Please contact us at (877) 232-4300 or info@crmp.org to add Design Professional information to your application.`,
                  'CONFIRM'
                );
              }
              console.warn(
                `ERROR: LdpForm.onLdpUnlisted - ${JSON.stringify(
                  error
                )}`
              );
            }
          );
        }
        if(isexists){

          const Contact: IContact = data.contact as IContact;

 
          const ldpId = Contact.id;

      
                         
          this.showSubmitBid(
            '2ndBid',
            ldpId,
            Contact.fullName,
            false
          );
     
        }
        }
      },
      error => {
        console.warn(
          `ERROR: LdpForm.onLdpUnlisted - ${JSON.stringify(
            error
          )}`
        );
      }
    );
  }
  isAuthorizedAndRequiredBid(): boolean {
    return (
      this.checkUploadAuthorization() === 3 &&
      this.application.programCycle.engineeredBidMustSubmitDoc === true
    );

  }
  public isHomeowner() : boolean {
    return this.authenticationService.isHomeowner(this.currentUser);
  }

  public isContractor(): boolean {
    return this.authenticationService.isContractor(this.currentUser);
  }
  // 1: no permissions;
  // 2: Contractor Review only
  // 3: ALL Edit;
  public checkUploadAuthorization(): number {
    const retVal = 3;
    //contractor is always read-only
    if (this.isContractor()) {
      return 1;
    }

    // submitted (preliminary review) - read only
    if (this.application.stageCode === 700000000 &&
        this.application.eventPreliminaryReview === true &&
        this.application.applicationStatusOptionSet !== 'Preliminary Review Rejected') {
      return 2;
    }

    // submitted (post-retrofit) - read only
    if (((this.application.stageCode === 700000001 &&
        this.application.eventApplicationSubmitted === true &&
        this.application.applicationStatusOptionSet !== 'Pending Approval') ||
        this.application.eventMitigationReviewSubmitted ||
        this.application.eventFinancialReviewSubmitted) &&
        (
          ( this.utilityService.bidLdpRequirementsMet(this.application, null, null, null,this.estimatemax))
        )
    ) {
      return 2;
    }

    //mitigation review - read only
    if (
      this.application.stageCode === 700000003 &&
      this.application.eventApplicationSubmitted === true &&
      this.application.eventFinancialReviewSubmitted === true
    ) {
      return 2;
    }

    return retVal;
  }
  private loadLdpData(id: string): void {
    this.apiContact.GetLdpByIdQuery(id, true).subscribe(
      ldp => {
        this.retrofitLdp = ldp;
        if (this.retrofitLdp.fullName) {
          this.taskRetrofitLdpSummary = this.retrofitLdp.fullName;
        }
      },
      error => console.warn(error)
    );
  }


  private loadLdpInfoForm(): void {


    
        if (this.application._Ebb_LdpId) {
          this.taskRetrofitLdpStatus = 'Selected';
          this.loadLdpData(this.application._Ebb_LdpId);
          this.apiApplicationBid
            .getApplicationBidList(this.application.id)
            .subscribe(applicationBids => {
              // Get only the bids submitted by the homeowner
              applicationBids = this.filterLdpBids(applicationBids);
              this.bids = applicationBids;
              // Get only the bids submitted for the selected ldp
              const applicationBidsForSelectedLdp: IApplicationBid[] = applicationBids.filter(
                bid =>
                  bid._Ebb_LdpId === this.application._Ebb_LdpId
              );

              // If the selected ldp has no bids (e.g. this is a newly selected ldp)
              if (
                applicationBidsForSelectedLdp.length < 1 &&
                (this.application.ldpBidAmount1 != null ||
                  this.application.ldpBidAmount1Selected != null ||
                  this.application.ldpBidAmount2 != null ||
                  this.application.ldpBidReason != null)
              ) {
                // Update application; set bid data to null
                const appInput: IApplicationInput = {} as IApplicationInput;
                appInput.ldpBidAmount1 = null;
                appInput.ldpBidAmount1Selected = null;
                appInput.ldpBidAmount2 = null;
                appInput.ldpBidReason = null;
               if(this.application.stateCode ==0 && this.application.statusCode !== 700000018){
               

                
                const events = [this.apiApplication.updateApplication(appInput, this.application.id)];
                events.push(this.deleteBids(this.application.id));

                forkJoin(events)
                  .pipe(defaultIfEmpty(null))
                  .subscribe(
                    () => {
                      this.emitLdpUpdateEvent.emit(appInput);
                    },
                    error => console.error(`ERROR: deleting application bid amounts - ${error}`)
                  );
                
                }
                // Because we have no bids for selected ldp, set the display options accordingly
                this.setBidDisplayOptions(0, false);
              } else {
                // Display second bid button in either of the following conditions.
                // 1) More than one bid exists.
                // 2) Only one bid exists AND its amount is > $10k AND multiple bids are required.
                const firstBid = applicationBids[0];
                const secondBid = applicationBids[1];
                const waitingForLdpEstimate =
                  applicationBids.length === 1 &&
                  firstBid.amount > this.estimatemax &&
                  this.application.programCycle.multipleEngineeredBidsRequired !== null &&
                  this.application.programCycle.multipleEngineeredBidsRequired === true;

                if (this.application.applicationStatus !== 700000004 &&
                  applicationBids.length > 0 &&
                  firstBid !== undefined &&
                  firstBid !== null &&
                  firstBid.amount !== undefined &&
                  firstBid.amount !== null) {
                  const appInput: IApplicationInput = {} as IApplicationInput;
                  appInput.ldpBidAmount1 = firstBid.amount;
                  appInput.ldpBidAmount1Selected = firstBid.selected === 'true' ? true : false;

                  appInput.ldpBidReason =
                   (applicationBids.length > 1 &&
                     appInput.ldpBidAmount1Selected === true &&
                     appInput.ldpBidAmount1 > this.estimatemax &&
                     appInput.ldpBidAmount1 > secondBid.amount &&
                     firstBid.reason !== null &&
                     firstBid.reason !== undefined) ||
                    (applicationBids.length > 1 &&
                      appInput.ldpBidAmount1Selected === false &&
                      secondBid.amount > appInput.ldpBidAmount1 &&
                      secondBid.reason !== null &&
                      secondBid.reason !== undefined) ||
                    applicationBids.length === 1 && firstBid.reason !== null && firstBid.reason !== undefined
                  ? true
                  : false;
                  if(this.oktoeditapplication() && appInput !== undefined){
                    
                  const events = [this.apiApplication.updateApplication(appInput, this.application.id)];

                  forkJoin(events)
                    .pipe(defaultIfEmpty(null))
                    .subscribe(
                      () => {
                        //
                      },
                      error => console.error(`ERROR: Updating application bid amount on application - ${error}`)
                    );
                    
                  }
                }

                this.setBidDisplayOptions(
                  applicationBids.length,
                  applicationBids.length <= 1
                    ? waitingForLdpEstimate
                      ? true
                      : false
                    : true
                );

                // If we have two bids, then we need to evaluate:
                // 1) whether the selected bid needs a reason
                // 2) Whether the other bid needs to be deleted
                if (applicationBids.length === 2) {
                  const bidFirst: IApplicationBid =
                    applicationBids[0].isFirstBid === 'true'
                      ? applicationBids[0]
                      : applicationBids[1];
                  const bidSecond: IApplicationBid =
                    applicationBids[0].isFirstBid === 'true'
                      ? applicationBids[1]
                      : applicationBids[0];
                  // If 1st bid is selected, perform further evaluation of bids
                  if (
                    bidFirst.selected === 'true' &&
                    this.application.ldpBidAmount1Selected === true
                  ) {
                    // If 1st bid amount is > $10,000
                    if (bidFirst.amount > this.estimatemax) {
                      // If 1st bid amount is > 2nd bid amount and no reason has been submitted for 1st bid
                      if (bidFirst.amount > bidSecond.amount && (bidFirst.reason === null || bidFirst.reason.length < 1)) {
                        // Reason is required; make the user submit a reason
                        this.showSubmitBid(
                          '1stBid',
                          bidFirst._Ebb_LdpId,
                          bidFirst._Ebb_LdpId_Formatted,
                          true
                        );
                      }
                    } else {
                      // Delete the 2nd bid (because 1st bid is <= $10,000).
                      this.apiApplicationBid
                        .delete({
                          id: bidSecond.id,
                          _Ebb_ApplicationId: bidSecond._Ebb_ApplicationId
                        } as IApplicationBidInput)
                        .subscribe(
                          res => console.log('2nd bid deleted'),
                          err => console.log('error deleting 2nd bid'),
                          () => console.log('2nd bid deletion attempt finished')
                        );
                      this.setBidDisplayOptions(1, false);
                    }
                  } else {
                    // Because 1st bid is not selected, assume 2nd bid is selected...
                    if (bidSecond.amount <= this.estimatemax) {
                      // Delete the 1st bid (because 2nd bid is <= $10,000 and is selected).
                      this.apiApplicationBid
                        .delete({
                          id: bidFirst.id,
                          _Ebb_ApplicationId: bidFirst._Ebb_ApplicationId
                        } as IApplicationBidInput)
                        .subscribe(
                          res => {
                            console.log('1st bid deleted');
                            // Update the value of the remaining bid to 'first bid = yes'
                            this.apiApplicationBid
                              .update({
                                id: bidSecond.id,
                                _Ebb_ApplicationId:
                                  bidSecond._Ebb_ApplicationId,
                                  bidType:700000000,
                                isFirstBid: 'true'
                              } as IApplicationBidInput)
                              .subscribe(
                                res =>
                                  console.log('2nd bid updated as 1st bid'),
                                err =>
                                  console.log(
                                    'error updating 2nd bid as 1st bid'
                                  ),
                                () =>
                                  console.log(
                                    '2nd bid update (to 1st bid) attempt finished'
                                  )
                              );
                          },
                          err => console.log('error deleting 1st bid'),
                          () => console.log('1st bid deletion attempt finished')
                        );
                      const appInput: IApplicationInput = {} as IApplicationInput;
                      appInput.ldpBidAmount1 = parseFloat(bidSecond.amount.toString());
                      appInput.ldpBidAmount1Selected = true;
                      appInput.ldpBidAmount2 = null;
                      appInput.ldpBidReason = null;
                      this.apiApplication
                        .updateApplication(appInput, this.application.id)
                        .subscribe(
                          res =>
                            console.log('Finished application bid amounts'),
                          err =>
                            console.error(
                              'ERROR: updating application bid amounts'
                            )
                        );
                      this.setBidDisplayOptions(1, false);
                    } else {
                      // If 2nd bid amount is > 1st bid amount and no reason has been submitted for 2nd bid
                      if (bidSecond.amount > bidFirst.amount &&
                        (bidSecond.reason === null ||
                          bidSecond.reason.length < 1)
                      ) {
                        // Reason is required; make the user submit a reason
                        this.showSubmitBid(
                          '2ndBidEdit',
                          bidSecond._Ebb_LdpId,
                          bidSecond._Ebb_LdpId_Formatted,
                          true
                        );
                      }
                    }
                  }
                }
              }
            });
        }
       
     
   

    
  }

   public onSubmitBidEvent(firstOrSecond: string): void {
   
      this.showSubmitBid(firstOrSecond, '', '', false);
   
  }
  get isSecondBidVisible(): boolean {
    return this.displaySecondBid !== false;
  }
  
  get isSecondBidEditMode(): boolean {
    return this.displaySecondBidLabel === 'EDIT';
  }

  private oktoeditapplication():boolean{
    var oktoedit = true;
        if ((
          this.application.applicationStatus === 700000009
       || this.application.applicationStatus == 700000005
       || this.application.applicationStatus == 700000012
       || this.application.applicationStatus == 700000010
       || this.application.applicationStatus == 700000016
       || this.application.applicationStatus == 700000004
       || this.application.applicationStatus == 700000006 
       || this.application.applicationStatus == 700000018
       )
       && (this.isContractor() || this.isHomeowner()))
    {
      oktoedit= false;
    }
    if(this.application.stateCode ==1 ){
      oktoedit= false;
    
    }
    
        return oktoedit;
      }
      private filterLdpBids(applicationBids: IApplicationBid[]) {
        applicationBids = applicationBids.filter(
          bid => bid.howSubmitted === 700000001 && bid.bidType === 700000001
        );
        return applicationBids;
      }
    
private showSubmitBid(
    firstOrSecond: string,
    bidLdpId: string,
    bidLdpName: string,
    reasonRequired: boolean
  ): void {
    const thisContext = this;
  
    this.apiApplicationBid
      .getApplicationBidList(this.application.id)
      .subscribe(applicationBids => {
        let bid1: IApplicationBid = null;
        let bid2: IApplicationBid = null;
        let dialogUploadDataItem: DialogUploadApplicationEngineeredBidData;
  
        applicationBids = this.filterLdpBids(applicationBids);
  
        if (applicationBids && applicationBids.length > 0) {
          if (firstOrSecond === '2ndBid' && applicationBids.length > 1) {
            const bidsToDelete = applicationBids.filter(
              bid => bid.isFirstBid === 'false'
            );
            this.deleteBid(
              bidsToDelete[0].id,
              bidsToDelete[0]._Ebb_ApplicationId
            ).subscribe();
            applicationBids = applicationBids.filter(
              bid => bid.isFirstBid === 'true'
            );
          }
  
          const bidA = applicationBids[0];
          const bidB = applicationBids.length > 1 ? applicationBids[1] : null;
          bid1 = bidA.isFirstBid === 'true' ? bidA : bidB;
          bid2 = bidA.isFirstBid === 'true' ? bidB : bidA;
          LdpFormComponent.prototype.setBids(bid1, bid2);
        }
  
        if (applicationBids && applicationBids.length > 2) {
          console.error('applicationBids.length=' + applicationBids.length);
        } else {
          let attachmentName: string = null;
          let ldpId: string = null;
          let ldpId2: string = null;
          let ldpName: string = null;
          let payload: string = null;
          let payloadName: string = null;
          let reason: string = null;
  
          attachmentName =
            firstOrSecond === '2ndBid'
              ? bidLdpName
              : this.retrofitLdp.fullName;
          ldpId =
            firstOrSecond === '2ndBid'
              ? bidLdpId
              : this.retrofitLdp.id;
  
          if (bid1 === null && firstOrSecond === '1stBid') {
            attachmentName = this.retrofitLdp.fullName;
            ldpId = this.retrofitLdp.id;
          } else if (bid1 !== null && firstOrSecond === '1stBid') {
            attachmentName = bid1.name.substr(
              bid1.name.indexOf('from') + 5
            );
            ldpId = bid1._Ebb_LdpId;
            if (bid1.payload !== null) {
              payload = bid1.payload;
              payloadName = bid1.payloadName;
            } else {
              bid1.payload = null;
              bid1.payloadName = null;
            }
            if (
              bid1.selected === 'true' &&
              bid2 !== null &&
              bid2.amount !== null &&
              bid1.amount > this.estimatemax &&
              bid1.amount > bid2.amount &&
              (bid1.reason === null || bid1.reason.length < 1)
            ) {
              reasonRequired = true;
            }
            reason =
              bid1.reason && bid1.reason.length > 0
                ? bid1.reason
                : null;
          } else if (
            firstOrSecond === '2ndBid' ||
            firstOrSecond === '2ndBidEdit'
          ) {
            attachmentName =
              firstOrSecond === '2ndBid'
                ? bidLdpName
                : firstOrSecond === '2ndBidEdit'
                  ? bid2.name.substr(bid2.name.indexOf('from') + 5)
                  : attachmentName;
            ldpId =
              bid1 !== null ? bid1._Ebb_LdpId : bidLdpId;
            ldpId2 =
              firstOrSecond === '2ndBid'
                ? bidLdpId
                : bid2._Ebb_LdpId;
            if (bid2 !== null && bid2.payload !== null) {
              payload = bid2.payload;
              payloadName = bid2.payloadName;
            }
          }
          ldpName = attachmentName;
  
          dialogUploadDataItem = {
            isImage: false,
            attachmentName: attachmentName,
            ldpName: ldpName,
            ldpId: ldpId,
            ldpId2: ldpId2,
            applicationId: this.application.id,
            ownerId: this.application._Ebb_OwnerId,
            ownerIdFormatted: this.application._Ebb_OwnerId_Formatted,
            firstOrSecond: firstOrSecond,
            isSelected: false,
            reasonRequired:
              reasonRequired &&
              this.application.programCycle.multipleEngineeredBidsRequired &&
              this.application.programCycle.multipleEngineeredBidsRequired === true,
            reason: reason,
            payload: payload,
            payloadName: payloadName,
            multipleBidsRequired:
              this.application.programCycle.multipleEngineeredBidsRequired &&
              this.application.programCycle.multipleEngineeredBidsRequired === true
          } as DialogUploadApplicationEngineeredBidData;
  
          let bidAm1: number = null;
          let bidAm2: number = null;
          if (bid1 !== null && firstOrSecond === '1stBid') {
            dialogUploadDataItem.id = bid1.id;
            dialogUploadDataItem.isSelected =
              bid1.selected === 'true' ? true : false;
            bidAm1 = bid1.amount;
            dialogUploadDataItem.reason = bid1.reason;
            if (bid2 === null) {
              bidAm2 = 0;
              dialogUploadDataItem.isSelected2 = false;
              dialogUploadDataItem.ldpId2 = '';
              dialogUploadDataItem.reason2 = null;
            } else {
              bidAm2 = bid2.amount;
              dialogUploadDataItem.ldpId2 = bid2._Ebb_LdpId;
              dialogUploadDataItem.bidId2 = bid2.id;
              dialogUploadDataItem.isSelected2 =
                bid2.selected === 'true' ? true : false;
              dialogUploadDataItem.reason2 = bid2.reason;
            }
          } else if (
            firstOrSecond === '2ndBid' ||
            firstOrSecond === '2ndBidEdit'
          ) {
            dialogUploadDataItem.id = bid1.id;
            dialogUploadDataItem.isSelected =
              bid1.selected === 'true' ? true : false;
            bidAm1 = bid1.amount;
            dialogUploadDataItem.reason = bid1.reason;
            if (bid2 === null) {
              bidAm2 = 0;
              dialogUploadDataItem.ldpId2 = bidLdpId;
              dialogUploadDataItem.bidId2 = '';
              dialogUploadDataItem.isSelected2 = false;
              dialogUploadDataItem.reason2 = null;
            } else {
              bidAm2 = bid2.amount;
              dialogUploadDataItem.ldpId2 =
                firstOrSecond === '2ndBid'
                  ? bidLdpId
                  : dialogUploadDataItem.ldpId2;
              dialogUploadDataItem.bidId2 = bid2.id;
              dialogUploadDataItem.isSelected2 =
                bid2.selected === 'true' ? true : false;
              dialogUploadDataItem.reason2 = bid2.reason;
            }
          }
          dialogUploadDataItem.estimatedCost = bidAm1;
          dialogUploadDataItem.estimatedCost2 = bidAm2;
          dialogUploadDataItem.estimatemax = this.estimatemax;
          const dialogRef = this.dialogUpload.open(
            DialogUploadApplicationEngineeredBidData,
            {
              width: '650px',             
              data: dialogUploadDataItem
            }
          );
  
          dialogRef.afterClosed().subscribe(async bidUploadResult => {
            if (
              bidUploadResult &&
              ((bidUploadResult.payload !== undefined &&
                bidUploadResult.payload !== null &&
                bidUploadResult.payload.length > 0) ||
                (bidUploadResult.uploadFile !== undefined &&
                  bidUploadResult.uploadFile !== null))
            ) {
              this.saveBidProgressIndicator = true;
              if (
                bidUploadResult.ldpId2 !== null &&
                bidUploadResult.ldpId2 === 'CHANGE'
              ) {
                // this.onOpenDirectoryEvent('2ndBid');
              } else {
                if (bidUploadResult.estimatedCost > this.estimatemax) {
                  const secondBidRequired: boolean =
                    this.application.programCycle.multipleEngineeredBidsRequired &&
                    this.application.programCycle.multipleEngineeredBidsRequired === true;
                  if (
                    bidUploadResult.estimatedCost2 !== null &&
                    bidUploadResult.estimatedCost2 > 0
                  ) {
                    this.setBidDisplayOptions(2, secondBidRequired);
                  } else {
                    this.setBidDisplayOptions(1, secondBidRequired);
                  }
                } else {
                  if (
                    bidUploadResult.estimatedCost2 !== null &&
                    bidUploadResult.estimatedCost2 > 0
                  ) {
                    this.setBidDisplayOptions(2, true);
                  } else {
                    this.setBidDisplayOptions(1, false);
                  }
                }
  
                LdpFormComponent.prototype.setBidUploadResult(
                  bidUploadResult
                );
                thisContext.bidUploadResultContext = bidUploadResult;
  
                let dateSentNow = new Date();
                dateSentNow.setHours(dateSentNow.getHours() + 7);
  
                let applicationBidInput: IApplicationBidInput;
  
                applicationBidInput = {
                  amount:
                    bidUploadResult.firstOrSecond === '1stBid'
                      ? parseFloat(bidUploadResult.estimatedCost)
                      : parseFloat(bidUploadResult.estimatedCost2),
                  name: `${this.application._Ebb_OwnerId_Formatted
                    } submitted bid from ${bidUploadResult.ldpName}`,
                  _Ebb_ApplicationId: bidUploadResult.applicationId,
                  _Ebb_OwnerId: bidUploadResult.ownerId,
                  _Ebb_LdpId:
                    bidUploadResult.firstOrSecond === '1stBid'
                      ? bidUploadResult.ldpId
                      : bidUploadResult.ldpId2,
                  selected:
                    bidUploadResult.firstOrSecond === '1stBid' &&
                      bidUploadResult.isSelected === true
                      ? 'true'
                      : (bidUploadResult.firstOrSecond === '2ndBid' ||
                        bidUploadResult.firstOrSecond === '2ndBidEdit') &&
                        bidUploadResult.isSelected2 === true
                        ? 'true'
                        : 'false',
                  dateSent: dateSentNow,
                  isFirstBid:
                    bidUploadResult.firstOrSecond === '1stBid'
                      ? 'true'
                      : 'false',
                  howSubmitted: 700000001,
                  bidType: 700000001,
                  reason:
                    bidUploadResult.firstOrSecond === '1stBid'
                      ? bidUploadResult.reason
                      : bidUploadResult.reason2
                } as IApplicationBidInput;
  
                if (
                  !isNull(bidUploadResult.id) &&
                  bidUploadResult.firstOrSecond !== '2ndBid' &&
                  bidUploadResult.firstOrSecond !== '2ndBidEdit'
                ) {
                  applicationBidInput.id = bidUploadResult.id;
                } else {
                  if (
                    !isNull(bidUploadResult.bidId2) &&
                    bidUploadResult.bidId2 !== '' &&
                    (bidUploadResult.firstOrSecond === '2ndBid' ||
                      bidUploadResult.firstOrSecond === '2ndBidEdit')
                  ) {
                    applicationBidInput.id = bidUploadResult.bidId2;
                  }
                }
  
                this.apiApplicationBid.update(applicationBidInput).subscribe(
                  async applicationBidId => {
                    if (applicationBidId) {
                      const savedApplicationBidId = applicationBidId;
  
                      if (
                        thisContext.bidUploadResultContext.uploadFileName &&
                        thisContext.bidUploadResultContext.uploadFileName
                          .length > 0
                      ) {
                        const savedBidUploadResult =
                          LdpFormComponent.prototype.getBidUploadResult();
                        const uploadFileName = savedBidUploadResult.uploadFileName.replace(
                          /[;,/?:@&=+$]/g,
                          ''
                        );
  
                        blobToBase64String(
                          savedBidUploadResult.uploadFile
                        ).then(base64string => {
                          const fileString64 = base64string;
                          const annotationInput: IAnnotationInput = {
                            id: null,
                            _Objectid_Value: applicationBidId,
                            objectTypeCode: 'cea_applicationbid',
                            fileName: uploadFileName,
                            fileSize: savedBidUploadResult.uploadFile.size,
                            mimeType: savedBidUploadResult.uploadFile.type,
                            subject: uploadFileName,
                            noteText: savedBidUploadResult.dateSent,
                            documentBody: fileString64
                          };
  
                          this.apiAnnotation
                            .saveAnnotation(annotationInput)
                            .subscribe(
                              annotation => {
                                const applicationBidInputForAnnotation = {
                                  id: savedApplicationBidId,
                                  _Ebb_ApplicationId:
                                    savedBidUploadResult.applicationId,
                                  payload: annotation.id,
                                  payloadName: uploadFileName
                                } as IApplicationBidInput;
  
                                this.apiApplicationBid
                                  .update(applicationBidInputForAnnotation)
                                  .subscribe(
                                    appBidId => {
                                      if (appBidId) {
                                        thisContext.updateAppAndBid(
                                          thisContext,
                                          dateSentNow
                                        );
                                      }
                                    },
                                    error => console.error(error)
                                  );
                              },
                              error => console.error(error)
                            );
                        });
                      } else {
                        if (
                          bidUploadResult.payload !== undefined &&
                          bidUploadResult.payload !== null &&
                          bidUploadResult.payload.length > 0
                        ) {
                          await thisContext.updateAppAndBid(
                            thisContext,
                            dateSentNow
                          );
                        }
                      }
                    }
                  },
                  error => console.error(error)
                );
              }
            } else {
              thisContext.loadLdpInfoForm();
            }
          });
        }
      });
  }

  
  private deleteBids(applicationId: string): Observable<any> {
    return this.apiApplicationBid
      .getApplicationBidList(applicationId)
      .pipe(mergeMap((applicationBids) => {
        applicationBids = this.filterLdpBids(applicationBids)

      return from(applicationBids).pipe(
        mergeMap(bid => {
          return this.deleteBid(bid.id, bid._Ebb_ApplicationId);
        })
      );
    }));
  }

  private deleteBid(bidId: string, applicationId: string): Observable<any> {
    const bidInput = {
      id: bidId,
      _Ebb_ApplicationId: applicationId
    } as IApplicationBidInput;

    return this.apiApplicationBid.delete(bidInput)
      .pipe(map(result => {
        if (!result) {
          console.log('error deleting bid');
        } else {
          console.log('bid deleted');
        }
        return result;
      }));
  }

  public setBids(bid1, bid2): void {
    this.bid1 = bid1;
    this.bid2 = bid2;
  }
  public async updateAppAndBid(thisContext, dateSentNow: Date): Promise<void> {
    // At this point, this bid/annotation has been submitted. Now, update the application with bid amounts from any submitted bids.
    const applicationInput: IApplicationInput = {} as IApplicationInput;

    let estimate2 =0;
    if (this.bidUploadResultContext.estimatedCost2) {
      // tslint:disable-next-line:radix
      estimate2 = Number.parseInt(this.bidUploadResultContext.estimatedCost2);
    }

    // tslint:disable-next-line:radix
    const estimate1 =  Number.parseInt(this.bidUploadResultContext.estimatedCost);
      // tslint:disable-next-line:radix
      if (this.bidUploadResultContext.isSelected2 && estimate2 < this.estimatemax) {
        applicationInput.ldpBidAmount1 = 0;
      } else {
        applicationInput.ldpBidAmount1 = parseFloat(estimate1.toString());
      }
    let applicationbids: IApplicationBid[];
    if (this.bidUploadResultContext.isSelected2 === true) {
      applicationbids = this.bids.filter(x => x.id === thisContext.bidUploadResultContext.id);

    } else if (this.bidUploadResultContext.isSelected === true) {
      applicationbids = this.bids.filter(x => x.id === thisContext.bidUploadResultContext.bidId2);

    }
    if (applicationbids.length > 0) {
      const bid = applicationbids[0];
      if (bid._Ebb_ApprovalTaskItemId) {
        for (let i = 0; i < this.taskBuildingPermit.approvalTaskItems.length; i++) {
          const obj = this.taskBuildingPermit.approvalTaskItems[i];

          if (obj.id === bid._Ebb_ApprovalTaskItemId) {
            this.taskBuildingPermit.approvalTaskItems.splice(i, 1);
          }
        }

      }
      this.bid1rejected = false;
    }

          if ( this.bids.length>1 &&
            (thisContext.bidUploadResultContext.isSelected === true &&
              thisContext.bidUploadResultContext.estimatedCost2 !== null &&
              thisContext.bidUploadResultContext.estimatedCost2 !== 0) ||
            thisContext.bidUploadResultContext.isSelected2 === true
          ) {
            let bidIdToDeselect = '';
            if (thisContext.bidUploadResultContext.isSelected2 === true)
            {
               bidIdToDeselect = thisContext.bidUploadResultContext.id;
               thisContext.bidUploadResultContext.isSelected=false;

            } else {
               bidIdToDeselect = thisContext.bidUploadResultContext.bidId2;
            }

            // If we have a bid to deselect
            if (bidIdToDeselect !== '' ) {
              // Deselect the bid
              const applicationBidInput = { id: bidIdToDeselect, _Ebb_ApplicationId: thisContext.bidUploadResultContext.applicationId, selected: 'false', reason: '', dateSent: dateSentNow } as IApplicationBidInput;

              this.apiApplicationBid
                .update(applicationBidInput)
                .subscribe(applicationBidId => {
                  if (applicationBidId) {
                  } else {
                    console.warn(
                      'error during attempt to deselect bid'
                    );
                  }
                });
            }


          } else {
            console.warn('neither bid is selected, no need to deselect one');
          }

    let selectedldpId = '';
    if (thisContext.bidUploadResultContext.isSelected === true) {
      selectedldpId = thisContext.bidUploadResultContext.ldpId;
    } else {
      selectedldpId = thisContext.bidUploadResultContext.ldpId2;
    }
    if (selectedldpId !==
      thisContext.application._Ebb_LdpId
    ) {

      
      applicationInput._Ebb_LdpId = selectedldpId;
      thisContext.application._Ebb_LdpId = selectedldpId;
    }
    if (estimate2 > 0){ applicationInput.ldpBidAmount2 = parseInt(estimate2.toString(), 10);}
    applicationInput.ldpBidReason =
      this.bidUploadResultContext.reason !== undefined &&
        this.bidUploadResultContext.reason !== null &&
        this.bidUploadResultContext.reason.length > 0
        ? true
        : this.bidUploadResultContext.isSelected2 &&
          this.bidUploadResultContext.reason2 !== undefined &&
          this.bidUploadResultContext.reason2 !== null &&
          this.bidUploadResultContext.reason2.length > 0
          ? true
          : false;
    applicationInput.ldpBidAmount1Selected = this.bidUploadResultContext
      .isSelected
      ? true
      : false;

   await this.apiApplication
      .updateApplication(applicationInput, this.application.id)
      .subscribe(
        () => {
          this.emitLdpUpdateEvent.emit(applicationInput);
          thisContext.loadLdpInfoForm();
          this.emitLdpFileUploadEvent.emit(this.taskBuildingPermit);
          thisContext.saveBidProgressIndicator = false;
         

        },
        error =>
          console.error(`ERROR: updating application bid amounts - ${error}`)
      );


  }
  public setBidDisplayOptions(bidCount: number, displaySecondEngBid: boolean) {
    switch (bidCount) {
      case 0: {
        this.displayFirstBidLabel = 'SUBMIT';
        this.displaySecondBidLabel = 'SUBMIT';
        this.displaySecondBid = displaySecondEngBid;
        break;
      }
      case 1: {
        this.displayFirstBidLabel = 'EDIT';
        this.displaySecondBidLabel = 'SUBMIT';
        this.displaySecondBid = displaySecondEngBid;
        break;
      }
      case 2: {
        this.displayFirstBidLabel = 'EDIT';
        this.displaySecondBidLabel = 'EDIT';
        this.displaySecondBid = displaySecondEngBid;
        break;
      }
      default: {
        this.displayFirstBidLabel = 'EDIT';
        this.displaySecondBidLabel = 'EDIT';
        this.displaySecondBid = true;
        break;
      }
    }
    this.displayFirstBidLabel = this.displayFirstBidLabel + ' ESTIMATE';
  }
  public setBidUploadResult(bidUploadObject): void {
    this.bidUploadResult = bidUploadObject;
  }
  public getBidUploadResult() {
    return this.bidUploadResult;
  }
  public onClickShowReasonWhy(topic: string): void {
    const item: IHelp = {} as IHelp;
    item.question = 'Reason Why';
    item.answer = topic.replace(/(\r\n|\n|\r)/gm, '<br/>');
    this.infoSheet.open(AppSheetHelpComponent, { data: item });
  }

}
